import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { RolesEnum } from 'src/app/core';
import { AfericaoService, StatusAfericaoDIO } from 'src/app/dio';
import { RemoveDialogService } from 'src/app/shared/components';
import { CancelarApontamentoComponent } from '../cancelar-apontamento/cancelar-apontamento.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr } from 'src/app/shared/utils';


@Component({
    selector: 'app-list-apontamentos',
    templateUrl: './list-apontamentos.component.html',
    styleUrls: ['./list-apontamentos.component.css'],
    standalone: false
})
export class ListApontamentosComponent {
  @Input() apontamentos: any[] = [];
  @Input() afericao = {} as any;
  @Input() currentRole = {} as any;
  @Input() dio = {} as any;
  
  @Output() cancelApontamento = new EventEmitter<any>();

  deletedCortes: string[] = [];

  constructor(
    private dialog: MatDialog,
    
    private removeDialogService: RemoveDialogService,
    private snackBar: MatSnackBar,
  ) {}

  responseCancelarApontamento(apontamento: any): void {
    this.cancelApontamento.emit(apontamento);
  }  

  checkDioFinishSameDay() {
    return dayjs(this.dio.dataInicioExecucao).isSame(this.dio.dataFimExecucao, 'day')
  }

  canAproveOrDeleteAfericao() {
    const rolesAllowed = [
        RolesEnum.GESTAO_ADMIN.toString(),
        RolesEnum.COORDENADOR.toString(),
    ].includes(this.currentRole);

    const status = this.afericao && this.afericao.status === StatusAfericaoDIO.AGUARDANDO_APROVACAO_AFERICAO;
    return rolesAllowed && status;
  }

  showCancelarApontamentoDialog(apontamento: any){        
    this.dialog.open(CancelarApontamentoComponent, { data: { apontamento } });
  }

  showDeletedCortesDialog(corte: any) {
    this.removeDialogService.show('',
        (dialogRef: MatDialogRef<any>) => {
            this.deletedCortes.push(corte.id);
            this.apontamentos = this.apontamentos.filter(({ id }) => id !== corte.id);
            dialogRef.close();
        },
        'Deseja mesmo apagar esse corte?',
        'Os cortes parciais so serao apagados quando terminar a aprovacao da afericao abaixo',
        'apagar'
    );
  }

}